import {
  IEditParams,
  ISavedBlockApi,
} from "@/schemas/savedBlock/savedBlockApiSchema";

export interface EditSavedBlockProps {
  name?: string;
  definition?: ISavedBlockApi["definition"];
  translation?: ISavedBlockApi["translation"];
  // number = move into that folder, null = move to root, undefined = unchanged
  toFolderId?: number | null;
}

export function buildEditSavedBlockParams(
  auth: Pick<IEditParams, "entity_id" | "hostname" | "key">,
  props: EditSavedBlockProps
): IEditParams {
  const params: IEditParams = { ...auth };

  if (props.toFolderId !== undefined) {
    params.folder_id = props.toFolderId;
  }

  if (props.definition) {
    const definition = JSON.parse(JSON.stringify(props.definition));
    (Array.isArray(definition) ? definition : [definition]).forEach(
      (s: any) => delete s.syncedLang
    );
    params.definition = definition;
  }
  if (props.name) {
    params.name = props.name;
  }
  if (props.translation !== undefined) {
    params.translation = props.translation;
  }

  return params;
}
